import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { HospitalService } from 'src/app/components/pages/_services';
import { TranslationService } from 'src/app/modules/i18n/translation.service';


@Component({
  selector: 'app-specialties',
  templateUrl: './specialties.component.html',
  styleUrls: ['./specialties.component.scss']
})
export class AppointmentSpecialtiesComponent implements OnInit, OnDestroy{
  language: any;
  HospitalSpecialties$:any[]=[];
  AllHospitalSpecialties$:any[]=[];
  SpecialtyDoctors;
  DoctorImg:boolean []= [];
  DoctorAbout:boolean [] = [];
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 

  constructor(private HospitalService: HospitalService, private translationService: TranslationService,
    private route: ActivatedRoute,private router: Router) { }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
    this.LoadAllSpecialties();
    this.LoadAllDoctors();
  }
  LoadAllSpecialties() {
    const sb =  this.HospitalService.GetHospitalDepartments().subscribe(res =>
      {
        this.HospitalSpecialties$ = res
        this.AllHospitalSpecialties$ = res
      });
    this.subscriptions.push(sb);
  }
  OnSearchSpecialty(Specialty) {
    let SearchTerm = Specialty.term;
    this.HospitalSpecialties$ =this.AllHospitalSpecialties$.filter(x => x.departmentName.toLower().includes(SearchTerm.toLower()) || x.departmentNameArabic.includes(SearchTerm))
    
  }
 
  OnChangeSpecialty(SpecialtyId)
  {
    const sb = this.HospitalService.GetAllDoctorsByDepartmentId(SpecialtyId).subscribe(res => {
      if (res != null) {
        this.SpecialtyDoctors = res;
        for(let i = 0 ; i < res.length ; i++)
        {
          this.DoctorImg[i] = true;
        }
      }
    });
    this.subscriptions.push(sb);
  }
  LoadAllDoctors(){
    const sb = this.HospitalService.GetAllDoctorsByDepartmentId(0).subscribe(res => {
      if (res != null) {
        this.SpecialtyDoctors = res;
        for(let i = 0 ; i < res.length ; i++)
        {
          this.DoctorImg[i] = true;
        }
      }
    });
    this.subscriptions.push(sb);
  }
  OnMouseEnter(index)
  {
    this.DoctorImg[index] = false;
    this.DoctorAbout[index] = true;
  }
  OnMouseLeave(index)
  {
    this.DoctorImg[index] = true;
    this.DoctorAbout[index] = false;
  }
  GetAppointment(DepartmentId,EmployeeId)
  {
    sessionStorage.setItem('DepartmentId',DepartmentId);
    sessionStorage.setItem('DoctorId',EmployeeId);
    this.router.navigate(['/portal/appointments/addappointment/' + DepartmentId + '/' + EmployeeId]);

  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
